import { StudentRole } from '../../types';
import { StudentDto } from './student.dto';

export class Student {
    id: string;
    schoolId: string;
    email: string;
    firstName: string;
    lastName: string;
    location: string;
    role: StudentRole;
    avatarSrc: string;
    description: string;
    pathIds: string[] = [];
    fullName: string;

    constructor(data: StudentDto) {
        this.id = data.id;
        this.schoolId = data.schoolId;
        this.pathIds = data.pathIds ?? [];
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.location = data.location;
        this.role = data.role;
        this.avatarSrc = data.avatarSrc;
        this.description = data.description;
        this.fullName = this.firstName && this.lastName ? `${this.firstName} ${this.lastName}` : '';
    }
}
